// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605250827/js/" + chunkId + "." + {"44":"92f0bf52","225":"643e3659","481":"9baf3e63","486":"59bf3389","770":"5d45cd43"}[chunkId] + ".0.8834782945035494.chunk.js";
};